import React from 'react';

export const Robot = ({ color, size, width }) => (
  <svg
    width={size ?? '50'}
    height={size ?? '50'}
    viewBox="0 0 75 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(1.23 2)"
      stroke={color ?? 'currentColor'}
      strokeWidth={width ?? '3'}
      fill="none"
      fillRule="evenodd"
    >
      <circle cx="35.769" cy="6" r="6" />
      <path d="M35.77 12v8.5" strokeLinecap="square" />
      <rect x="10.269" y="20.5" width="52" height="40" rx="8" />
      <circle cx="22.769" cy="36" r="4" />
      <circle cx="49.769" cy="36" r="4" />
      <path
        d="M8.77 33c-5.334 1.79-8 4.623-8 8.5s2.666 6.71 8 8.5M63.77 33c5.333 1.79 8 4.623 8 8.5s-2.667 6.71-8 8.5M28.764 51c2.876.667 5.376 1 7.5 1 2.123 0 4.626-.333 7.509-1"
        strokeLinecap="square"
      />
    </g>
  </svg>
);
